import axios from 'axios';
import sessionHelper from './sessionHelper';
// const siteUrl = 'http://shepa.ca-language.com/api/';
//const siteUrl = 'https://test.shepa.com/api/';//process.env.siteUrl;//
const siteUrl = process.env.VUE_APP_BASE_URL;
//const siteUrl = 'http://127.0.0.1:8001/api/';
let onlineTime = 1801;
class HttpHelper {
    config = {
        baseURL: siteUrl,
        timeout: 180000,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };
    getOnlineTime() {
        return onlineTime;
    }
    setOnlineTime(value) {
        // if (onlineTime > value) {
        //     return;
        // }
        onlineTime = value;
    }
    constructor() { }
    getData(url) {
        this.setOnlineTime(1801);
        url = url;
        // console.log('url' , url);
        // console.log('this.config' , this.config);
        return new Promise((resolve, reject) => {
            axios.get(url, this.config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.error = true;
                    if(error.response.status == 401){
                      window.location = '/';
                    }
                    reject(error);
                })
                .then(() => {
                    this.loading = false;
                });
        });
    }
    setAuth() {
        this.config.headers.Authorization = 'Bearer ' + sessionHelper.getUser().token


    }
    postData(url, dataToSend) {
        this.setOnlineTime(1801);
        //document.body.className += ' page-loading';
        url = siteUrl + url;
        // console.log('url' , url);
        // console.log('dataToSend' , dataToSend);
        // console.log('this.config' , this.config);
        return new Promise((resolve, reject) => {
            axios({
                method: "POST",
                url: url,
                headers: this.config.headers,
                data: dataToSend
            }).then((response) => {
                //document.body.className = document.body.className.replace(" page-loading","");
                resolve(response.data);
            }).catch((error) => {
                console.log('postData', error);
                if(error.response.status == 401){
                  window.location = '/';
                }
                reject(error);
            });
        });
    }
    UploadFile(file) {
        var url = siteUrl + 'upload';
        let formData = new FormData();
        formData.append("file", file);
        return new Promise((resolve, reject) => {
            axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': 'Bearer ' + sessionHelper.getUser().token
                }
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                if(error.response.status == 401){
                  window.location = '/';
                }
                reject(error);
            });
        });

    }
}
const httpHelper = new HttpHelper();
export default httpHelper;
